import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangle = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 8 6",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4 0L8 6H0L4 0Z",
		fill: "currentColor"
	})
});
export default SvgTriangle;
